import type { FC } from 'react';
import { Card, Modal, ModalCloseButton } from '..';
import type { ModalWithCardProps } from './types';

export * from './types';

export const ModalWithCard: FC<ModalWithCardProps> = (props) => {
  const { containerProps, modalProps, children } = props;
  const { size = 'small', isModal = true, ...containerPropsRest } = containerProps ?? {};

  return (
    <Modal {...modalProps} shrinkHeight>
      <Card
        isModal={isModal}
        size={size}
        style={{
          margin: '0 auto',
          height: 'min-content',
        }}
        containerProps={{
          style: {
            ...containerPropsRest.containerProps?.style,
            paddingTop: 60,
            borderRadius: '20px 20px 0 0',
            height: 'min-content',
          },
          ...containerPropsRest.containerProps,
        }}
        {...containerPropsRest}
      >
        <ModalCloseButton modal={modalProps} />
        {children}
      </Card>
    </Modal>
  );
};
